<script>
  import { getContext, onMount } from "svelte"
  import { get } from "svelte/store";
  import GanttChartBox from "../../components/ganttchart/GanttChartBox.svelte"
  import { postStartEndData } from "../../utils/putData.js"
  import { usePageContext } from "../../components/pages/pageContext.js"
  import { FetchError, fetchResGanttProjectInfo } from "../../utils/getData.js";
  import Loading from "../../components/pages/Loading.svelte";
  import { batchUpdateGanttStore, initGanttStore } from "../../components/ganttchart/ganttStore/init.js";
  import {
    mapProjectInfoToGanttStoreProperties
  } from "../../components/ganttchart/ganttStore/mapProjectInfoToGanttStoreProperties.js";
  import {
    connectSimpleResGanttConfigurationToGanttStore,
    getSimpleResGanttConfiguration,
    saveSimpleResGanttConfiguration
  } from "../../views/generic/SimpleResGantt/SimpleResGanttConfigurationStorage.js";
  import { createSimpleResGanttFilters } from "../../views/generic/SimpleResGantt/SimpleResGanttFilters.js";
  import { connectSearchParamsToGanttStore } from "../../utils/searchParams/connectGanttStore.js";

  export let projectId
  export let user

  const GanttStore = initGanttStore()

  const resource_url = `/api/projects/${projectId}/ResGantt/res/`;
  const transaction_url = `/api/projects/${projectId}/transactions`;
  let projectInfo = null;

  // New GanttChart vars
  let projectData;
  let uploadTimeStamp;
  let downloadTimeStamp;
  let styleDict;
  let searchTables;
  let transactions;
  let readyToRender = false;

  const {setHeaderProps} = usePageContext()
  $: setHeaderProps({title: projectInfo?.Project[5] ? `${projectInfo.Project[5]} (資源ガントチャート(シンプル版))`: "資源ガントチャート(シンプル版)"})
  $: setHeaderProps({uploadTime: uploadTimeStamp})
  
  function fetchTransactionData(timestamp) {
    console.log("timestamp: " + timestamp);
    let _trUrl = transaction_url;
    if (timestamp)
      _trUrl += "?timestamp=" + timestamp;
    const xhr = new XMLHttpRequest();
    xhr.open("GET", _trUrl, false);
    xhr.send();

    if (xhr.status === 200) {
      return JSON.parse(xhr.responseText);
    }
    else {
      console.error("Failed to fetch transactions");
      return null;
    }
  }

  async function registerTransaction(operations) {
    // console.log("operations: ");
    // console.log(operations);
    let data = {};
    operations.forEach((ope) => {
      data[ope._operation] = {
        "Work_ResultStartTime": ope._resultStart,
        "Work_ResultEndTime": ope._resultEnd,
        "Work_Status": ope._resStatus,
        "Work_ResultQty": ope._resultQty,
        "Work_ResultProgress": ope._resultProgress,
        "Work_ResultObtainTime": ope._resultObtainTime
      };
    });

    return postStartEndData(projectId, JSON.stringify(data))
  }


  function fetchStyleInfo(styles) {
    const _styleDict = {};
    const _searchTables = {};

    styles.forEach((style) => {
      const _styleUrl = `/api/projects/${projectId}/ResGantt/styles/${style.ObjectID}.json`;
      const xhr = new XMLHttpRequest();
      xhr.open("GET", _styleUrl, false);
      xhr.send();

      if (xhr.status === 200) {
        _styleDict[style.StyleName] = JSON.parse(xhr.responseText);
      }
      else {
        console.error("Failed to fetch style " + style);
      }

       // Search table
       const _tableUrl = `/api/projects/${projectId}/ResGantt/searchTables/${style.ObjectID}.json`;
      const xhrT = new XMLHttpRequest();
      xhrT.open("GET", _tableUrl, false);
      xhrT.send();

      if (xhrT.status === 200) {
        _searchTables[style.StyleName] = JSON.parse(xhrT.responseText);
        console.log("Search tables found for style " + style.StyleName);
      }
      else {
        console.error("Failed to fetch seatch table for style " + style.StyleName);
      }

    });
    transactions = fetchTransactionData(downloadTimeStamp);
    styleDict = _styleDict;
    searchTables = _searchTables;
  }

  const {handleFetchErrors} = getContext("fetchErrorHandler")

  onMount(async () => {
    try {
      projectInfo = await fetchResGanttProjectInfo(projectId);
      projectData = projectInfo.Project;
      uploadTimeStamp = projectInfo.UploadTimeStamp;
      downloadTimeStamp = projectInfo.LastDownloadTimeStamp;
      fetchStyleInfo(projectData[7]);

      // Do not support dayStartTime, OtherDemarcationTimes for simple gantt charts for now
      batchUpdateGanttStore(GanttStore, {
        ...mapProjectInfoToGanttStoreProperties(projectInfo),
        GanttChartType: GanttStore.GanttChartTypes.SimpleResGantt,
        ProjectId: projectId,
        UserId: user.id,
        StylesDict: styleDict,
        SearchTables: searchTables,
        RowDownloadUrl: resource_url,
        Transactions: transactions,
        TransactionsUrl: transaction_url,
        TransactionRegisteringFunction: registerTransaction,
        ExtraColumns: [
          {
            name: "資源グループ",
            nameTranslationKey: "$t(asprova.terms.resourceGroup)",
            code: "ResourceGroup",
            filterName: "ResourceGroupFilter",
            expectedLength: 8,
            displayed: false
          },
          {
            name: "資源名",
            nameTranslationKey: "$t(asprova.terms.resourceName)",
            code: "ResourceName",
            filterName: "ResourceNameFilter",
            expectedLength: 12,
            displayed: false
          },
          {
            name: "シフト",
            code: "ResourceShift",
            filterName: "ResourceShiftFilter",
            expectedLength: 5,
            displayed: false
          },
        ],
      })
      GanttStore.Filters.set(createSimpleResGanttFilters(get(GanttStore.RowsAllOwnedByStyle)))
      const cfg = getSimpleResGanttConfiguration(user.id, projectId)
      if (cfg.displaySpanInSeconds == 604800 && cfg.rowCount == 5) {
        // Hard Code: this is the default configuration
        cfg.displaySpanInSeconds = 2592000; // 30 days
        cfg.rowCount = 10;
      }
      saveSimpleResGanttConfiguration(cfg, user.id, projectId);

      await connectSimpleResGanttConfigurationToGanttStore(GanttStore, user.id, projectId)
      await connectSearchParamsToGanttStore(GanttStore)

      readyToRender = true;
    } catch (e) {
      console.log(e)
      if (e instanceof FetchError) {
        handleFetchErrors(e.error)
      }
    }
  });

</script>
  
{#if readyToRender === true}
  <GanttChartBox
    GanttStore={GanttStore}
    boxDimensions="height: calc(100% - 5px);"
    projectData={projectData}
  />
{/if}
{#if projectInfo == null}
  <Loading/>
{/if}
